import { Box, Checkbox, Col, Colors, IcScreen, Row, StatusTag, Text } from 'basic-ui-lib';
import { IScreen } from 'modules/dashboard/interfaces/api';
import { StatusScreenConfigs } from 'modules/dashboard/services/constants';
import styled from 'styled-components';

interface SetToScreenMobileItemProps {
  screen: IScreen;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

const SetToScreenMobileItem = ({ screen, checked, onChange }: SetToScreenMobileItemProps) => {
  const handleToggle = () => {
    onChange?.(!checked);
  };

  const config = StatusScreenConfigs[screen.status];

  return (
    <Container onClick={handleToggle}>
      <Row>
        <Box
          padding={10}
          borderRadius={8}
          display='flex'
          alignItems='center'
          justifyContent='center'
          backgroundColor={Colors.neutral.bg[2]}
        >
          <IcScreen width={24} height={24} fill={Colors.neutral.bg[7]} />
        </Box>
        <Col flex={1} display='flex' flexDirection='column' alignItems='flex-start' gap={4} marginLeft={4}>
          <Text body_1 left semibold>
            {screen.playerName}
          </Text>
          <Text left caption_3 regular color='neutral.text.6'>
            {screen.businessName}
          </Text>
        </Col>
      </Row>
      <Row alignItems='center' gap={16}>
        <StatusTag label={config.label} backgroundColor={config.backgroundColor} color={config.color} />
        <Checkbox value={checked} onChange={(value) => onChange?.(value)} />
      </Row>
    </Container>
  );
};

export default SetToScreenMobileItem;

const Container = styled.div`
  display: flex;
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${Colors.neutral.bg[5]};
  padding: 16px;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  background-color: ${Colors.neutral.bg[1]};

  .ant-checkbox-inner {
    border: 1px solid ${Colors.neutral.border[3]};
  }
`;
